import AnimatedSection from '@/components/base/AnimatedSection';

export default function CTASection() {
  return (
    <section id="cta" className="relative w-full min-h-[80vh] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20nightclub%20atmosphere%20with%20blurred%20neon%20red%20and%20pink%20lights%2C%20mysterious%20underground%20vibe%2C%20smoke%20and%20laser%20streaks%2C%20cinematic%20widescreen%2C%20dark%20moody%20texture%2C%20gritty%20urban%20nightlife%20aesthetic&width=1920&height=1000&seq=cta-bg-main&orientation=landscape"
          alt="传送门入口"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/90 via-background-50/60 to-background-50/90" />
      </div>

      {/* Content - triangle layout */}
      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 py-20">
        <AnimatedSection animation="fade-in">
        <div className="relative min-h-[50vh]">
          {/* Top-left: Main headline */}
          <div className="absolute top-0 left-0 max-w-2xl">
            <h2 className="text-[clamp(2.5rem,5vw,5rem)] font-black text-foreground-50 leading-[0.95] tracking-[-0.03em]">
              传送门已开启
            </h2>
          </div>

          {/* Bottom-right: Description */}
          <div className="absolute bottom-[140px] right-0 max-w-md text-right">
            <p className="text-lg md:text-xl text-foreground-400 font-light leading-relaxed">
              每天凌晨零点<br />最新猛料准时送达<br />设为星标不迷路
            </p>
          </div>

          {/* Bottom-left: CTA */}
          <div className="absolute bottom-0 left-0">
            <a
              href="#video-grid"
              className="inline-flex items-center gap-3 group cursor-pointer"
            >
              <span className="px-6 py-3.5 bg-foreground-50 text-background-950 text-sm font-bold rounded-full whitespace-nowrap transition-all duration-300 hover:bg-primary-500">
                直达最新内幕
              </span>
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-foreground-50 text-background-950 group-hover:translate-x-1 transition-transform duration-300">
                <i className="ri-arrow-right-line text-xl"></i>
              </span>
            </a>
          </div>
        </div>
        </AnimatedSection>
      </div>
    </section>
  );
}